export enum ViewType {
    Null = 0,
    Video = 1,
    Tipsheet = 2,
    BlogPost = 7,
    ATEArchived = 5
}